module.exports = __webpack_public_path__ + "static/media/344.d55db78c.jpg";